import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  RuleSelectWrapper,
  RuleSelectedOptionWrapper,
  RuleSelectorIconWrapper,
  RuleSelectorClearIcon,
  RuleSelectorOptionsWrapper,
  RuleSelectorOptionsList,
} from "./RuleSelector.styled";
import { Icon } from "../../../../../elements";

const RuleSelector = ({
                        suffix = "",
                        defaultValue,
                        options,
                        onSelect,
                        onClear,
                        className,
                        dataTestId,
                      }) => {
  const [openOptions, setOpenOptions] = useState(false);
  const [value, setValue] = useState("");
  const wrapperRef = useRef(null);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const onHandleSelect = useCallback((option) => {
      setOpenOptions(false);
      setValue(option.value);
      onSelect && onSelect(option);
    },
    [onSelect]
  );

  const onHandleClick = useCallback(() => {
    setOpenOptions((prev) => !prev);
  }, []);

  const onHandleClear = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setValue("");
    onClear && onClear();
  }, [onClear]);

  const handleClickOutside = useCallback((event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOpenOptions(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const optionsFiltered = useMemo(() => {
    return options || [];
  }, [options]);

  return (
    <RuleSelectWrapper ref={wrapperRef} data-testid={dataTestId} onClick={onHandleClick}>
      <RuleSelectedOptionWrapper>
        {suffix && suffix}
        <span>
          {options?.find((option) => value === option.value)?.name || ""}
        </span>
      </RuleSelectedOptionWrapper>
      {value && (
        <RuleSelectorClearIcon onClick={onHandleClear}>✕</RuleSelectorClearIcon>
      )}
      <RuleSelectorIconWrapper >
        <Icon name={"arrowDown"} width={"10px"} height={"10px"} />
      </RuleSelectorIconWrapper>
      {openOptions && (
        <RuleSelectorOptionsWrapper>
          <RuleSelectorOptionsList>
            {optionsFiltered.map((option, index) => (
              <p
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  onHandleSelect(option);
                }}
              >
                {option.name}
              </p>
            ))}
          </RuleSelectorOptionsList>
        </RuleSelectorOptionsWrapper>
      )}
    </RuleSelectWrapper>
  );
};

export default RuleSelector;